import { CurrencyEnum, useCustomToasts } from '@systemeio/ui'
import { useEffect, useState } from 'react'

export const useCurrency = ({
  initCurrency,
  currencyChangeMessage,
}: {
  initCurrency?: CurrencyEnum
  currencyChangeMessage: string
}) => {
  const [currentCurrency, setCurrentCurrency] = useState<CurrencyEnum | undefined>(initCurrency)
  const [toastShown, setToastShown] = useState(false)
  const { infoToast } = useCustomToasts()

  useEffect(() => {
    if (initCurrency) {
      setCurrentCurrency(initCurrency)
    }
  }, [initCurrency])

  const showToast = () => {
    if (toastShown) return
    infoToast(currencyChangeMessage)
    setToastShown(true)
  }

  return { currentCurrency, setCurrentCurrency, showToast }
}
